import { useState } from "react";
import { testimonials } from "@/mocks/homeData";

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c === 0 ? total - 1 : c - 1));
  const next = () => setCurrent((c) => (c === total - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-4xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            What Users Say
          </h2>
          <p className="text-foreground-500 text-sm">
            Trusted by product researchers and e-commerce sellers worldwide
          </p>
        </div>

        {/* Testimonial card */}
        <div className="relative bg-background-100 rounded-2xl p-8 md:p-12">
          {/* Rating badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold mb-6">
            <i className="ri-star-fill text-sm"></i>
            {t.rating}/5 Rating
          </div>

          {/* Quote */}
          <blockquote className="text-lg md:text-xl text-foreground-800 font-heading italic leading-relaxed mb-8">
            &ldquo;{t.content}&rdquo;
          </blockquote>

          {/* Author */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-secondary-300 flex items-center justify-center">
              <span className="text-secondary-700 font-semibold text-sm">
                {t.name.charAt(0)}
              </span>
            </div>
            <div>
              <p className="text-foreground-900 font-medium text-sm">{t.name}</p>
              <p className="text-foreground-500 text-xs">{t.role}</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={prev}
            className="w-10 h-10 rounded-full border border-background-200 flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-foreground-600"></i>
          </button>
          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === current ? "bg-primary-500 w-6" : "bg-background-300"
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-10 h-10 rounded-full border border-background-200 flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-foreground-600"></i>
          </button>
        </div>
      </div>
    </section>
  );
}